const comments = [
  {
    name: '追剧达人小王',
    text: '用了69视频半年多了，西瓜视频免费资源真的很全，更新速度也快，基本上想看的剧都能找到。画质清晰流畅，推荐给身边好多朋友了！',
    rating: 5,
  },
  {
    name: '电影爱好者阿杰',
    text: '91在线视频的入口很方便，分类清晰，找片效率高。特别是港片专区，很多经典老片在这里都能看，画质修复得也不错，满满的回忆！',
    rating: 5,
  },
  {
    name: '上班族小李',
    text: '每天下班回家就想躺着看剧放松，69视频不用注册直接看这一点太方便了。资源丰富，综艺更新也及时，周末追综艺的首选平台。',
    rating: 4,
  },
  {
    name: '学生党小陈',
    text: '放暑假在家无聊，发现了69视频这个宝藏平台。动漫资源很全，国漫日漫都有，画质高清播放流畅。唯一的建议是希望弹幕功能更加丰富。',
    rating: 4,
  },
  {
    name: '家庭主妇张姐',
    text: '平时喜欢看电视剧和综艺，69视频分类做得很好，找剧很方便。电视剧更新也快，不用等太久就能看到新的一集，推荐给闺蜜们了！',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <span className="text-xs text-secondary-400 whitespace-nowrap">用户心声</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">用户评价</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            来自真实用户的观影反馈，他们都在69视频找到了喜欢的西瓜视频免费和91在线视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.slice(0, 3).map((c) => (
            <div key={c.name} className="bg-background-200/60 rounded-xl p-5">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm w-4 h-4 flex items-center justify-center ${
                      i < c.rating ? 'text-accent-400' : 'text-foreground-600'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed mb-4">{c.text}</p>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <span className="text-xs text-primary-400 font-medium">{c.name[0]}</span>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{c.name}</span>
              </div>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {comments.slice(3).map((c) => (
              <div key={c.name} className="bg-background-200/60 rounded-xl p-5">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-sm w-4 h-4 flex items-center justify-center ${
                        i < c.rating ? 'text-accent-400' : 'text-foreground-600'
                      }`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-300 leading-relaxed mb-4">{c.text}</p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                    <span className="text-xs text-primary-400 font-medium">{c.name[0]}</span>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{c.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}